"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = __importDefault(require("@mui/material/Button"));
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const variantStyles = {
    text: {
        minWidth: 'unset',
    },
    link: {
        minWidth: 'unset',
        padding: 0,
        color: 'primary.main', //theme.palette.primary.main,
        '&:hover': {
            backgroundColor: 'transparent', //not sure this is really doing anything
        },
    },
    muted: {
        color: 'grey.600',
        borderColor: 'grey.600',
    },
    'outlined-simple': {
        borderColor: 'grey.600',
        '&:hover': {
            borderColor: 'grey.600',
            backgroundColor: 'grey.100',
        },
    },
};
const Button = ({ variant = 'text', sx, loading = false, squared = false, endIcon, ...rest }) => {
    let muiVariant;
    if (variant === 'link') {
        muiVariant = 'text';
    }
    else if (variant === 'muted' || variant === 'outlined-simple') {
        muiVariant = 'outlined';
    }
    else {
        muiVariant = variant;
    }
    return (
    // @ts-ignore
    react_1.default.createElement(Button_1.default, { sx: {
            textTransform: 'none', //If we want it upper case, type it upper case...
            minWidth: '80px', //overwitten by link and text variants
            boxShadow: 'none',
            // @ts-ignore
            ...variantStyles[variant],
            borderRadius: squared ? 2 : null,
            ...sx,
        }, variant: muiVariant, endIcon: loading ? react_1.default.createElement(index_1.CircularProgress, { size: 24 }) : endIcon, ...rest }));
};
exports.default = Button;
